import type { GlobalState } from '../../types';

type SyncFlagState = Pick<
GlobalState,
'auth' | 'connectionState' | 'isFetchingDifference' | 'isSynced' | 'isSyncing'
>;

export function degradeSyncFlagsForConnection<T extends SyncFlagState>(
  global: T,
  connectionState: GlobalState['connectionState'],
): T {
  if (connectionState === 'connectionStateReady') {
    return global;
  }

  return {
    ...global,
    isSynced: false,
    isSyncing: false,
    isFetchingDifference: false,
  };
}

export function finalizeSyncFlags<T extends SyncFlagState>(global: T): T {
  const isReadyToMarkSynced = global.connectionState === 'connectionStateReady'
    && global.auth.state === 'authorizationStateReady';

  return {
    ...global,
    isSyncing: false,
    isSynced: isReadyToMarkSynced,
    isFetchingDifference: false,
  };
}
